var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mine-block",
      class: _vm.getClass,
      on: {
        click: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "left", 37, $event.key, [
              "Left",
              "ArrowLeft"
            ])
          ) {
            return null
          }
          if ("button" in $event && $event.button !== 0) {
            return null
          }
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.leftClick($event)
        },
        contextmenu: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.rightClick($event)
        }
      }
    },
    [
      _vm.isOpened
        ? _c("span", [
            _vm._v(
              _vm._s(
                _vm.mineState
                  ? _vm.mineState === -1 ? "*" : _vm.mineState
                  : ""
              )
            )
          ])
        : _vm.isFlagged ? _c("span", [_vm._v("F")]) : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fde65dcc", { render: render, staticRenderFns: staticRenderFns })
  }
}